export const LOGS_FILTERS_LABELS = {
  dateFrom: "Date From:",
  dateTo: "Date To:",
  type: "Type:",
  message: "Message:",
  action: "Action:",
  createdByName: "User:",
};

export const FILTERS_TEMPLATE = {
  action: "",
  message: "",
  type: "",
  dateFrom: "",
  dateTo: "",
  createdByName: "",
};



// WEBPACK FOOTER //
// ./src/features/log/constants/logFilters.js